var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"TimePeriodNav"}},[_c('span',{staticClass:"icon-toggle psDateToggle",on:{"click":_vm.clickback}}),_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('span',{staticClass:"icon-play-24 psDateToggle",on:{"click":_vm.clickforward}})])
}
var staticRenderFns = []

export { render, staticRenderFns }